import { createSlice } from "@reduxjs/toolkit";
import {      home_tradeConfirmationDataThunk } from "./thunk";


export const initialState = {
  home_tradeConfirmData: [],
  home_tradeConfirmError: {
    code: null,
    message: '',
    data: null
  },
  home_tradeConfirmLoading: false,
  
  
};

const Home_TradeConfirm = createSlice({
  name: "Home_TradeConfirm",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_tradeConfirmationDataThunk.pending, (state) => {
      state.home_tradeConfirmLoading = true ;
      state.home_tradeConfirmError = initialState.home_tradeConfirmError; 
      state.home_tradeConfirmData = [];
  });
    builder.addCase(home_tradeConfirmationDataThunk.fulfilled, (state, action) => {
        state.home_tradeConfirmData = action.payload.data;
        state.home_tradeConfirmLoading = false ;
    });
    builder.addCase(home_tradeConfirmationDataThunk.rejected, (state, action) => {
      state.home_tradeConfirmError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.home_tradeConfirmLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_TradeConfirm.actions

export default Home_TradeConfirm.reducer;